<template>
  <div class="js-tools">
    <div class="code-list">
      <textarea class="beforeCode" v-model="inputCode"
                style="margin-right: 10px"
                placeholder="粘贴待美化的代码"></textarea>
      <textarea class="afterCode" v-model="beautifiedCode" disabled placeholder="美化后的代码"></textarea>
    </div>

    <div class="button-list">
      <div @click="handleCodeChange">美化</div>
      <div @click="cleanse">净化</div>
      <div @click="encryption">加密</div>
      <div @click="decrypt">解密</div>
    </div>
  </div>
</template>

<script>
import prettier from 'prettier';
import parserBabel from 'prettier/parser-babel';
import { minify } from 'terser';
import CryptoJS from "crypto-js";
export default {
  data() {
    return {
      inputCode: '',
      beautifiedCode: '',
    };
  },
  mounted() {

  },
  methods: {
    //美化
     handleCodeChange() {
       try {
         this.beautifiedCode = prettier.format(this.inputCode, {
           parser: "babel",
           plugins: [parserBabel]
         });
       } catch (error) {
         console.error('Prettier error:', error.message);
       }
    },
    //压缩
    async cleanse() {
      try {
        minify(this.inputCode).then(res=>{
          this.beautifiedCode = res.code;
        });
      } catch (error) {
        console.error('Code compression error:', error);
      }
    },
    //加密
    encryption() {
      let pwd = CryptoJS.enc.Utf8.parse(this.inputCode) // 解析明文
      let key = CryptoJS.enc.Utf8.parse('abcdef0123456789') // 解析密钥
      let iv = CryptoJS.enc.Utf8.parse('abcdef0123456789')
      const encrypted = CryptoJS.AES.encrypt(pwd, key, {
        mode: CryptoJS.mode.CBC, // 加密模式
        padding: CryptoJS.pad.Pkcs7, // 填充方式
        iv // 向量
      })
      this.beautifiedCode = encrypted.toString() // 加密后的结果是对象，要转为文本

      // 加上ciphertext 就变成十六进制的了
      // return encrypted.ciphertext.toString()
    },

    //解密
    decrypt() {
      let key = CryptoJS.enc.Utf8.parse('abcdef0123456789') // 解析密钥
      let iv = CryptoJS.enc.Utf8.parse('abcdef0123456789')
      const encrypted = CryptoJS.AES.decrypt(this.inputCode, key, {  // 解析的密文必须是base64编码（data） 这很关键！
        mode: CryptoJS.mode.CBC, // 加密模式
        padding: CryptoJS.pad.Pkcs7, // 填充方式
        iv // 向量
      })
      this.beautifiedCode = encrypted.toString(CryptoJS.enc.Utf8) // 加密后的结果是对象，要转为文本
    }

  },
};
</script>

<style lang="scss">
*{
  margin: 0px;
  padding: 0px;
}
.js-tools{
  padding-bottom: 20px;
  .code-list{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .button-list{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    div{
      margin-right: 10px;
      margin-top: 10px;
      padding: 5px 10px;
      font-size: 13px;
      border: 1px solid #064627;
      cursor: pointer;
      display: inline-block;
      color: #064627;
      &:hover{
        background-color: #eeeeee;
      }
    }
  }
}

/* 样式可以根据需要自行添加 */
h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

textarea {
  width: 100%;
  height: 500px;
  margin-bottom: 10px;
}

pre {
  white-space: pre-wrap;
}
</style>
